import { ActionTypes } from '../constants/actionTypes';

const initialState = {
   userInfo : {
    emailid: "",
   },
   role:[],
   permissions:[],
   isLogoutClicked:false,
   navigtorOpen : false
}

export const authorizationClaimsReducer = (state= initialState, {type, payload}) => {
  switch(type) {
    case ActionTypes.SET_AUTHORIZATION_USERINFO:
        return{...state,
            userInfo: {
                emailid: payload.email,
            }
        };
    case ActionTypes.SET_NAVIGATION_DRAWER_STATE:
      return {
        ...state,
        navigtorOpen: !state.navigtorOpen,
      }
    case ActionTypes.SET_PORTAL_LOGOUT:
      return {
        ...state,
        isLogoutClicked:payload,
      }
    case ActionTypes.SET_USER_ROLES:
      return {
        ...state,
        role: payload
      }
      case ActionTypes.SET_USER_PERMISSIONS:
      return {
        ...state,
       permissions: payload
      }
    default:
    return state;
  }
}